<template>
  <div class="kt-form kt-form--label-right">
    <p>Agency or Direct details - The fields in this section auto-populate both the consumer Sales Flyer and Landing Page.<br> Navigate where these fields are displayed on the outputs here <span data-v-ea3d52d4=""><svg data-v-ea3d52d4="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="info-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-info-circle fa-w-16 fa-lg"><path data-v-ea3d52d4="" fill="currentColor" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z" class=""></path></svg></span>.</p>

    <div class="row">
      <div class="form-group col col-md-6 mb-4">
        <BaseLabelWithPopover label="Call to action: <small> Max. 3 Lines</small>" width="350px">
          <h6>Sales Flyer (PDF)</h6>
          <hr><img src="/img/popover/ConsumerSection_PopOver_CalltoAction.png" alt="" width="350">
          <table style="width: 100%;">
          <tbody>
          <tr>
          <td style="text-align: center;"><strong>3</strong> Lines<br></td>
          <td style="text-align: center;"><strong>3</strong>  Lines<br></td>
          <td style="text-align: center;"><strong>3</strong>  Lines<br></td>
          </tr>
          </tbody>
          </table>
          <p>&nbsp;</p>
          <h6>Landing Page (Online): </h6>
          <hr><img src="/img/popover/ConsumerSection_PopOver_CalltoAction_L.png" alt="" width="350">

        </BaseLabelWithPopover>

        <Editor
          :showDebugger="false"
          :height="100"
          placeholder="Ex. Here you add extra information related to it."
          :toolbar="['heading', '|', 'bold', 'italic', 'undo', 'redo']"
          v-model="$v[validationGroupName].consumerSection.yourDetails.callToAction.$model"
          @blur="$v[validationGroupName].consumerSection.yourDetails.callToAction.$touch()"
          :validator="$v[validationGroupName].consumerSection.yourDetails.callToAction" />
      </div>
      <div class="form-group col col-md-6 mb-0">
        <BaseLabelWithPopover label="Upload company logo:" width="350px">
          <h6>Sales Flyer (PDF)</h6>
          <hr><img src="/img/popover/ConsumerSection_PopOver_Logo.png" alt="" width="350">
          <p>&nbsp;</p>
          <h6>Landing Page (Online): </h6>
          <hr><img src="/img/popover/ConsumerSection_PopOver_Logo_L.png" alt="" width="350">
        </BaseLabelWithPopover>

        <FileUpload
          :isDisabled="false"
          :config="uploadCompanyLogoConfig">
          <template v-slot:info="{ config }">
            <small>
              <div>Maximum upload file size: {{ config.maxSize }}</div>
              <div>Accepted file types: {{ config.acceptedMimeTypesLabels }}</div>
            </small>
          </template>
        </FileUpload>
      </div>
    </div>

    <div class="row">
      <div class="form-group col col-md-6 col-12">
        <BaseLabelWithPopover label="Upload Tour Host Photo:" width="350px">
          <h6>Sales Flyer (PDF)</h6>
          <hr><img src="/img/popover/ConsumerSection_PopOver_HostPhoto.png" alt="" width="350">
          <p>&nbsp;</p>
          <h6>Landing Page (Online): N/A</h6>
        </BaseLabelWithPopover>

        <FileUpload
          :isDisabled="false"
          :config="uploadTourHostPhotoConfig">
          <template v-slot:info="{ config }">
            <small>
              <div>Maximum upload file size: {{ config.maxSize }}</div>
              <div>Accepted file types: {{ config.acceptedMimeTypesLabels }}</div>
            </small>
          </template>
        </FileUpload>
      </div>
      <div class="form-group col col-md-6"></div>
    </div>

    <div class="row">
      <div class="form-group col col-md-4 col-12">
        <BaseLabelWithPopover label="Tour Host Name:" width="350px">
          <h6>Sales Flyer (PDF)</h6>
          <hr><img src="/img/popover/ConsumerSection_PopOver_HostName.png" alt="" width="350">
          <p>&nbsp;</p>
          <h6>Landing Page (Online): N/A</h6>
        </BaseLabelWithPopover>

        <BaseInputForm
          type="text"
          placeholder="Ex. Lydia Scuglia"
          v-model="$v[validationGroupName].consumerSection.yourDetails.tourHostName.$model"
          @blur="$v[validationGroupName].consumerSection.yourDetails.tourHostName.$touch()"
          :validator="$v[validationGroupName].consumerSection.yourDetails.tourHostName" />
      </div>

      <div class="form-group col col-md-4 col-12">
        <BaseLabelWithPopover label="Tour Host Position:" width="350px">
          <h6>Sales Flyer (PDF)</h6>
          <hr><img src="/img/popover/ConsumerSection_PopOver_HostPosition.png" alt="" width="350">
          <p>&nbsp;</p>
          <h6>Landing Page (Online): N/A</h6>
        </BaseLabelWithPopover>

        <BaseInputForm
          type="text"
          placeholder="Ex. from Helloworld Travel Top Ryde City"
          v-model="$v[validationGroupName].consumerSection.yourDetails.tourHostPosition.$model"
          @blur="$v[validationGroupName].consumerSection.yourDetails.tourHostPosition.$touch()"
          :validator="$v[validationGroupName].consumerSection.yourDetails.tourHostPosition" />
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Editor from '@/components/_shared/Editor.vue'
import FileUpload from '@/components/_shared/file-upload/FileUpload.vue'

export default {
  name: 'TabYourDetails',
  inject: ['$v'],
  components: { Editor, FileUpload },
  props: {
    validationGroupName: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      'opportunityDetails': 'opportunity/opportunityDetails'
    }),
    uploadCompanyLogoConfig () {
      const uuid = this.$route.params.privateId
      const userId = this.opportunityDetails ? this.opportunityDetails.owner : null
      return {
        uuid,
        path: `images/files/opportunity/${uuid}/consumer-section/company-logo`,
        userId,
        minSize: '1KB',
        maxSize: '20MB',
        multiple: false,
        acceptedMimeTypes: [
          { ext: '.png', mimeType: 'image/png' },
          { ext: '.jpg, .jpeg', mimeType: 'image/jpeg' }
        ]
      }
    },
    uploadTourHostPhotoConfig () {
      const uuid = this.$route.params.privateId
      const userId = this.opportunityDetails ? this.opportunityDetails.owner : null
      return {
        uuid,
        path: `images/files/opportunity/${uuid}/consumer-section/tour-host-photo`,
        userId,
        minSize: '1KB',
        maxSize: '20MB',
        multiple: false,
        acceptedMimeTypes: [
          { ext: '.png', mimeType: 'image/png' },
          { ext: '.jpg, .jpeg', mimeType: 'image/jpeg' }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scopep>
</style>
